<lib-datepicker
    class="size-s"
    mode="inline-range"
    [formControl]="formControl"
>
</lib-datepicker>
